import { motion } from 'framer-motion';
import { useMetaStore } from '@/engine/state';
import { borrarTodo } from '@/engine/persistence';

export function CosmicGameOver() {
  const razon = useMetaStore((s) => s.cosmicGameOverRazon);

  const reset = () => {
    borrarTodo();
    window.location.reload();
  };

  return (
    <div className="relative h-full w-full flex items-center justify-center overflow-hidden bg-ash-950">
      <div className="absolute inset-0 bg-vignette" aria-hidden />
      <motion.div
        className="absolute inset-0"
        animate={{
          background: [
            'radial-gradient(circle at 30% 40%, rgba(237,95,30,0.08), transparent 60%)',
            'radial-gradient(circle at 70% 60%, rgba(96,101,177,0.1), transparent 60%)',
            'radial-gradient(circle at 30% 40%, rgba(237,95,30,0.08), transparent 60%)',
          ],
        }}
        transition={{ duration: 8, repeat: Infinity, ease: 'easeInOut' }}
        aria-hidden
      />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.6, ease: 'easeOut' }}
        className="relative z-10 max-w-2xl px-6 text-center space-y-6"
      >
        <motion.h1
          className="text-display fluid-3xl text-ember-300 tracking-[0.2em]"
          animate={{ opacity: [0.75, 1, 0.75] }}
          transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
        >
          EL TEJIDO SE HA FRACTURADO
        </motion.h1>

        <div className="text-narrative text-ash-200 fluid-base italic space-y-3">
          <p>Algo en vos intentó doblar la realidad. La realidad no perdona eso.</p>
          <p>
            Las palabras que construían este mundo se han desatado. Los capibaras duermen,
            las facciones se disuelven en ceniza, Pipo ha olvidado tu nombre.
          </p>
          <p className="text-ember-400">
            No hay vuelta atrás. Solo queda empezar otra vez, desde el principio,
            con las manos vacías.
          </p>
        </div>

        {razon && (
          <p className="fluid-xs text-ash-600 font-ui uppercase tracking-widest">{razon}</p>
        )}

        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={reset}
          type="button"
          className="mt-3 px-6 py-2.5 border border-ember-600 text-ember-200 font-display tracking-widest uppercase fluid-xs hover:bg-ember-900/40 transition-colors"
        >
          Aceptar la ceniza
        </motion.button>
      </motion.div>
    </div>
  );
}
